import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  ChevronDownIcon,
  EnvelopeIcon,
  PhoneIcon,
  MapPinIcon
} from '@heroicons/react/24/outline';

const Footer = () => {
  const [openSection, setOpenSection] = useState('');

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? '' : section);
  };

  const footerSections = {
    services: {
      title: 'Services',
      links: [
        { name: 'Vehicle Service', path: '/servicing' },
      ]
    },
    company: {
      title: 'Company',
      links: [
        { name: 'About Us', path: '/about-us' },
        { name: 'Contact', path: '/contact-us' },
      ]
    },
    support: {
      title: 'Support',
      links: [
        { name: 'Help Center', path: '/faq' },
        { name: 'My Bookings', path: '/service-history' },
        { name: 'Terms of Service', path: '/terms-and-conditions' },
        { name: "Privacy Policy", path: "/privacy-policy" },
        { name: 'Refund Policy', path: '/refund-policy' },
      ]
    }
  };

  const socialLinks = [
    {
      name: 'Facebook',
      href: 'https://www.facebook.com/profile.php?id=61577013062800',
      icon: (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      )
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/okbikerentals?igsh=OTQyM3Y2cDMweGY3',
      icon: (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      )
    },
    {
      name: 'Twitter',
      href: '#',
      icon: (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
        </svg>
      )
    },
    {
      name: 'LinkedIn',
      href: '#',
      icon: (
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      )
    }
  ];

  return (
    <footer className="bg-[#111111] text-gray-400">

      {/* Orange top accent line */}
      <div className="h-0.5 bg-gradient-to-r from-transparent via-[#FF6B35] to-transparent opacity-60" />

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-14">

        {/* Desktop layout */}
        <div className="hidden md:grid md:grid-cols-12 gap-8">

          {/* Brand */}
          <div className="md:col-span-4">
            <Link to="/" className="inline-flex items-center gap-3 mb-5 group">
              <img
                src="/logo.png"
                alt="OkMechanic Logo"
                className="h-10 w-auto"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
              <span className="text-white font-bold text-lg group-hover:text-[#FF6B35] transition-colors">
                Ok<span className="text-[#FF6B35]">Mechanic</span>
              </span>
            </Link>
            <p className="text-sm text-gray-500 mb-6 leading-relaxed">
Your trusted partner for reliable bike servicing and maintenance in Pune.            
            </p>

            {/* Contact info */}
            <div className="space-y-3 mb-6">

               <h4 className="text-white font-semibold text-base">
    Shabnam Hamir Khan
  </h4>
  
     <a
                href="tel:+919923887090"
                className="flex items-center text-sm hover:text-[#FF6B35] transition-colors group"
              >
                <PhoneIcon className="w-4 h-4 mr-2.5 text-[#FF6B35] flex-shrink-0" />
                +91 9923887090
              </a>
              <a
                href="mailto:okmechanics@gmail.com"
                className="flex items-center text-sm hover:text-[#FF6B35] transition-colors group"
              >
                <EnvelopeIcon className="w-4 h-4 mr-2.5 text-[#FF6B35] flex-shrink-0" />
                okmechanics@gmail.com
              </a>
              <div className="flex items-start text-sm">
                <MapPinIcon className="w-4 h-4 mr-2.5 mt-0.5 text-[#FF6B35] flex-shrink-0" />
                <span className="text-gray-500">
6, Gen Vaidya Marg Agarkar Nagar Pune, Maharashtra 411001 India                </span>
              </div>
            </div>

            {/* Social links */}
            <div className="flex gap-2">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.name}
                  className="w-9 h-9 bg-white/5 rounded-lg flex items-center justify-center hover:bg-[#FF6B35] hover:text-white text-gray-500 transition-all duration-200 border border-white/5"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Link sections */}
          {Object.entries(footerSections).map(([key, section]) => (
            <div key={key} className="md:col-span-2">
              <h3 className="text-white font-semibold text-sm mb-4 flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-[#FF6B35] rounded-full" />
                {section.title}
              </h3>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-gray-500 hover:text-[#FF6B35] transition-colors"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* App download */}
          <div className="md:col-span-2">
            <h3 className="text-white font-semibold text-sm mb-4 flex items-center gap-2">
              <span className="w-1.5 h-1.5 bg-[#FF6B35] rounded-full" />
              Download App
            </h3>
            <a
              href="https://play.google.com/store/apps/details?id=com.okmechanic"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block hover:opacity-80 transition-opacity"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
                className="h-11 w-auto"
              />
            </a>
          </div>
        </div>

        {/* Mobile layout */}
        <div className="md:hidden space-y-6">

          {/* Brand mobile */}
          <div className="pb-5 border-b border-white/10">
            <Link to="/" className="inline-flex items-center gap-2.5 mb-3 group">
              <img
                src="/logo.png"
                alt="OkMechanic Logo"
                className="h-8 w-auto"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
              <span className="text-white font-bold group-hover:text-[#FF6B35] transition-colors">
                Ok<span className="text-[#FF6B35]">Mechanic</span>
              </span>
            </Link>
            <p className="text-xs text-gray-500 mb-4">
Your trusted partner for reliable bike servicing and maintenance in Pune.            </p>

            <div className="space-y-2 mb-4">
              <a href="tel:+919923887090" className="flex items-center text-xs hover:text-[#FF6B35] transition-colors">
                <PhoneIcon className="w-3.5 h-3.5 mr-2 text-[#FF6B35]" />
                +91 9923887090
              </a>
              <a href="mailto:okmechanics@gmail.com" className="flex items-center text-xs hover:text-[#FF6B35] transition-colors">
                <EnvelopeIcon className="w-3.5 h-3.5 mr-2 text-[#FF6B35]" />
                okmechanics@gmail.com
              </a>
            </div>

            <div className="flex gap-2">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-8 h-8 bg-white/5 rounded-lg flex items-center justify-center hover:bg-[#FF6B35] text-gray-500 hover:text-white transition-all border border-white/5"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Collapsible sections mobile */}
          {Object.entries(footerSections).map(([key, section]) => (
            <div key={key} className="border-b border-white/10">
              <button
                onClick={() => toggleSection(key)}
                className="w-full flex items-center justify-between py-3"
              >
                <h3 className="text-white font-semibold text-sm">{section.title}</h3>
                <ChevronDownIcon
                  className={`w-4 h-4 text-gray-500 transition-transform ${openSection === key ? 'rotate-180' : ''}`}
                />
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openSection === key ? 'max-h-96 pb-4' : 'max-h-0'}`}>
                <ul className="space-y-2">
                  {section.links.map((link) => (
                    <li key={link.path}>
                      <Link
                        to={link.path}
                        className="text-sm text-gray-500 hover:text-[#FF6B35] transition-colors"
                        onClick={() => setOpenSection('')}
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}

          {/* App download mobile */}
          <div className="pt-2">
            <h3 className="text-white font-semibold text-sm mb-3">Download App</h3>
            <a
              href="https://play.google.com/store/apps/details?id=com.okmechanic"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block hover:opacity-80 transition-opacity"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
                className="h-10 w-auto"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-600">
            <p>© {new Date().getFullYear()} OkMechanic. All rights reserved.</p>
            <div className="flex items-center gap-4">
              <Link to="/terms-and-conditions" className="hover:text-[#FF6B35] transition-colors">Terms</Link>
              <span className="text-gray-700">•</span>
              <Link to="/refund-policy" className="hover:text-[#FF6B35] transition-colors">Privacy</Link>
              <span className="text-gray-700">•</span>
              <Link to="/contact-us" className="hover:text-[#FF6B35] transition-colors">Support</Link>
            </div>
          </div>
        </div>
      </div>

      {/* SEO Keywords */}
      <div className="sr-only">
  OkMechanic,
  OkMechanics,
  bike servicing Pune,
  bike service Pune,
  two wheeler service Pune,
  bike repair Pune,
  bike maintenance Pune,
  doorstep bike service,
  bike service at home,
  bike pickup and drop,
  motorcycle service Pune,
  scooter service Pune,
  bike service center Pune,
  bike repair service,
  bike maintenance service,
  bike service booking,
  online bike service booking,
  bike service packages,
  bike service appointment,
  two wheeler maintenance,
  bike service app,
  OkMechanic Pune,
  OkMechanics Pune,
  OkMechanic bike service,
  OkMechanics bike servicing,
  OkMechanic app
</div>
    </footer>
  );
};

export default Footer;
